import { render, staticRenderFns } from "./trainingcategorycard.vue?vue&type=template&id=70e4495a&lang=pug"
import script from "./trainingcategorycard.vue?vue&type=script&lang=js"
export * from "./trainingcategorycard.vue?vue&type=script&lang=js"
import style0 from "./trainingcategorycard.vue?vue&type=style&index=0&id=70e4495a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports